import translations from '../../components/TrustList/TrustList.translations'

export const satisfactionItem = ({ days }) => {
  return {
    id: 'reassurance_item_satisfaction',
    icon: 'IconGoodPrices',
    i18n: {
      translation: translations.satisfaction,
      params: { days },
    },
  }
}
